import { MaterialIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const Insights: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialIcons name="insights" size={size} color={color} />
);
